// ** React Imports
import { Suspense, lazy, useEffect , React } from 'react'
import ReactDOM from 'react-dom'
// ** Redux Imports
import { Provider } from 'react-redux'
import { store } from './redux/storeConfig/store'

  const productsListInitil = [
    {
      id: 1,
      name: 'Power Products & Industry',
      businessUnit : 'Power Products',
      check: 'Power Products & Industry',
      slugname: 'PPI',
      slug: 'PPI',
      unitName :'PP&I'
    }
  ]
   const users =  [
    {
      id: 1,
      fullName: '',
      username: '',
      password: '',
      email: '',
      userRoleId: "",
      userRoleName: ''
    }
  ]
  const getLocalProduct = localStorage.getItem("Product")
  const getLocalRole = localStorage.getItem("UserData")
  const tokenGet = localStorage.getItem('AuthToken')
  const MonthGet = localStorage.getItem('MonthSet')
  const TokenExpiredGet = localStorage.getItem('TokenExpired')

  if (getLocalProduct === null) {
    localStorage.setItem("Product", JSON.stringify(productsListInitil[0]))
  }
  if (getLocalRole === null) {
    localStorage.setItem("UserData", JSON.stringify(users[0]))
  }
   if (tokenGet === null) {
    localStorage.setItem("AuthToken", '')
  }
   if (MonthGet === null) {
   localStorage.setItem("MonthSet",'default')
  }
  if (TokenExpiredGet === null) {
   localStorage.setItem("TokenExpired",'')
  }

  const parseJwt = token => {
    try {
      return JSON.parse(atob(token.split('.')[1]))
    } catch (e) {
      return null
    }
  }
   const paths = location.pathname.split('/')
 
    if (tokenGet !== '' && paths[1] !== 'login') {
        const decodedJwt = parseJwt(tokenGet)
        if (decodedJwt.exp * 1000 < Date.now()) {
          localStorage.setItem("AuthToken", '')
          localStorage.setItem("TokenExpired", true)
           // history.replace('/')
          location.replace('/')
        }
    }


import { RawWorkOrderDetails, RawDumpWorkOrderDetails, WOApprovedListDetails, WOGetPreviousMonthDetails } from '@store/actions/rawworkorder'

import { CSSWorkOrderDetails, CSSWOInvoiceDetails, CSSCurrentStatusDetails, CSSGradationDetails, CSSNoDueListDetails } from '@store/actions/redux-css'
import { NotificationDetails, RegionDetails, UserDetails, CSSUserDetails } from '@store/actions/common'
import { adminProduct } from '@store/actions/admin'
import { superAdminRateCard } from '@store/actions/superAdmin'
import { gradationDashboard, paymentDashboard, paymentValueDashboard, purchaseOrderDashboard } from '@store/actions/dashboard'
const productGet = JSON.parse(window.localStorage.getItem('Product'))
 const auth = JSON.parse(window.localStorage.getItem('UserData'))
import {GetMonthYear, productsList, GetCurrentDate} from '@src/function.js'
//Dispatch the fetchPosts() before our root component renders

if (tokenGet !== '') {
  store.dispatch(NotificationDetails())
  store.dispatch(RegionDetails())
  if (auth.userTypeId === 0) {
  	store.dispatch(UserDetails())
  	store.dispatch(CSSUserDetails())
  	store.dispatch(adminProduct())
  }
  if (auth.userTypeId === 1) {
  	store.dispatch(RawDumpWorkOrderDetails(productGet.slug))
  	store.dispatch(RawWorkOrderDetails(productGet.slug))
  	store.dispatch(CSSWOInvoiceDetails(productGet.slug))
  	store.dispatch(CSSCurrentStatusDetails(productGet.slug))
  	store.dispatch(CSSGradationDetails())
  	// store.dispatch(WOApprovedListDetails(productGet.slug))
    store.dispatch(WOApprovedListDetails(`BusinessUnit=${productGet.slug}&MonthName=${GetMonthYear()}`))
  	store.dispatch(WOGetPreviousMonthDetails())
  	// -----------dashboard
  	store.dispatch(gradationDashboard(`FromDate=${GetCurrentDate()}&ToDate=${GetCurrentDate()}`))
  	store.dispatch(paymentDashboard('GroupBy=BusinessUnit'))
  	store.dispatch(paymentValueDashboard('GroupBy=BusinessUnit'))
  	store.dispatch(purchaseOrderDashboard())
  }
  if (auth.userTypeId === 3) {
  	if (auth.businessUnit !== null) {
  		var str = auth.businessUnit
  		var array = str.split('&')
  		const productFind = Object.assign(
  			{},
  			...productsList.filter(c => c.businessUnit === array[0].trim())
  		)
  		// const productFind = "PPI"
  		store.dispatch(RawWorkOrderDetails(productFind.slug))
  		store.dispatch(CSSWOInvoiceDetails(productFind.slug))
  		store.dispatch(CSSCurrentStatusDetails(productFind.slug))
  		store.dispatch(CSSGradationDetails())
  		localStorage.setItem('Product', JSON.stringify(productFind))
  	} else {
  		store.dispatch(RawWorkOrderDetails(productGet.slug))
  		store.dispatch(CSSWOInvoiceDetails(productGet.slug))
  		store.dispatch(CSSCurrentStatusDetails(productGet.slug))
  		store.dispatch(CSSGradationDetails())
  		localStorage.setItem('Product', JSON.stringify(productsList[0]))
  	}
  	// -----------dashboard
  	store.dispatch(gradationDashboard(`FromDate=${GetCurrentDate()}&ToDate=${GetCurrentDate()}`))
  	store.dispatch(paymentDashboard('GroupBy=BusinessUnit'))
  	store.dispatch(paymentValueDashboard('GroupBy=BusinessUnit'))
  	store.dispatch(purchaseOrderDashboard())
  	store.dispatch(CSSNoDueListDetails())

  }
  if (auth.userTypeId === 2) {
  	store.dispatch(CSSWorkOrderDetails(productGet.slug))
  	store.dispatch(CSSCurrentStatusDetails(productGet.slug))
  	store.dispatch(CSSWOInvoiceDetails(productGet.slug))
  	store.dispatch(CSSGradationDetails())

  	// -----------dashboard
  	store.dispatch(gradationDashboard(`FromDate=${GetCurrentDate()}&ToDate=${GetCurrentDate()}`))
  	store.dispatch(paymentDashboard('GroupBy=BusinessUnit'))
  	store.dispatch(paymentValueDashboard('GroupBy=BusinessUnit'))
  	store.dispatch(purchaseOrderDashboard())
  }
  if (auth.userTypeId === 4) {
  	// store.dispatch(CSSWorkOrderDetails(productGet.slug))
  	store.dispatch(CSSCurrentStatusDetails(productGet.slug))
  	store.dispatch(CSSWOInvoiceDetails(productGet.slug))
  	store.dispatch(CSSGradationDetails())
  	// store.dispatch(WOApprovedListDetails(productGet.slug))
    store.dispatch(WOApprovedListDetails(`BusinessUnit=${productGet.slug}&MonthName=${GetMonthYear()}`))
  	// -----------dashboard
  	store.dispatch(gradationDashboard(`FromDate=${GetCurrentDate()}&ToDate=${GetCurrentDate()}`))
  	store.dispatch(paymentDashboard('GroupBy=BusinessUnit'))
  	store.dispatch(paymentValueDashboard('GroupBy=BusinessUnit'))
  	store.dispatch(purchaseOrderDashboard())
  }
  if (auth.userTypeId === 5) {
  	store.dispatch(CSSWOInvoiceDetails(productGet.slug))
  }
  if (auth.userTypeId === 6) {
  	store.dispatch(superAdminRateCard())
  }
}
// ------------------------------------------------------------------------------------------------------------------------------------
// ** Toast & ThemeColors Context
import { ToastContainer } from 'react-toastify'
import { ThemeContext } from './utility/context/ThemeColors'
import moment from 'moment'

// ** Spinner (Splash Screen)
import Spinner from './@core/components/spinner/Fallback-spinner'

// ** Ripple Button
import './@core/components/ripple-button'

// ** PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import 'prismjs/components/prism-jsx.min'

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css'

// ** React Toastify
import '@styles/react/libs/toastify/toastify.scss'

// ** Core styles
import './@core/assets/fonts/feather/iconfont.css'
import './@core/scss/core.scss'
import './assets/scss/style.scss'

// ** Service Worker
import * as serviceWorker from './serviceWorker'

// ** Lazy load app
const LazyApp = lazy(() => import('./App'))

ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={<Spinner />}>
      <ThemeContext>
        <LazyApp />
        <ToastContainer newestOnTop />
      </ThemeContext>
    </Suspense>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
